export default function _arrayFromIterator(iter) {
  var list = [];
  var next;

  while (!(next = iter.next()).done) {
    list.push(next.value);
  }

  return list;
}


//////////////////
// WEBPACK FOOTER
// ./~/ramda/es/internal/_arrayFromIterator.js
// module id = 1714
// module chunks = 1